import { apiFetch, API_BASE_URL } from "@/lib/api-client";
import { auth } from "@duress/shared";

export async function fetchMe(): Promise<auth.AuthedUser> {
  return apiFetch("/auth/me", auth.MeResponseSchema);
}

export async function logout(): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/auth/logout`, {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) {
    throw new Error(`Logout failed (${res.status})`);
  }
}
